app.directive('regulationDomains', [
    '$rootScope', 'RegulationApiService', 'utilsService',
    function ($rootScope, RegulationApiService, utilsService) {
        var DEFAULT_INDEX = 0;
        return {
            restrict: 'AE',
            template: '<div class="regulation__domains">' +
            '<div ng-if="domains_loader" ng-class="{\'active\': loading}" class="ui inverted dimmer"><div class="ui loader text">Chargement des domaines...</div></div>' +
            '<div class="ui vertical pointing menu"><div class="item active regulation__domains__selected" ng-if="hasSelectedDomain()"><div class="ui circular primary icon button regulation__domains__back-button" ng-click="goBack()" data-tooltip="Précédent" data-position="right center"><i class="backward icon"></i></div><div class="ui circular icon button regulation__domains__back-button" ng-click="goBack(true)" data-tooltip="Revenir au début" data-position="right center"><i class="fast backward icon"></i></div><span class="regulation__domains__selected-name" title="{{ selectedDomain.name }}">{{ selectedDomain.name }}</span></div><a ng-if="currentDomains.length" ng-repeat="domain in currentDomains track by $index" ng-click="goToDomain(domain)" class="item" ng-class="{\'active\': hasSelectedDomain() && selectedDomain.id == item.id}">{{ domain.name }}</a></div>' +
            '</div>',
            link: function (scope) {
                scope.loading = false;
                scope.domains = {};
                scope.qualeveilleDomains = {};
                scope.regulationDomains = {};
                scope.currentDomains = [];
                scope.selectedDomain = {};
                scope.breadcrumb = [];

                scope.goToDomain = function (domain, ignoreBreadcrumb) {
                    ignoreBreadcrumb = ignoreBreadcrumb || false;
                    scope.selectedDomain = domain;
                    var ids = [scope.selectedDomain.id];

                    if (scope.selectedDomain.regulation_domain_id !== undefined) {
                        if (scope.selectedDomain.regulation_domain_id !== null) {
                            scope.domains = scope.regulationDomains;
                            if (angular.isArray(scope.selectedDomain.regulation_domain_id) && scope.selectedDomain.regulation_domain_id.length) {
                                ids = scope.selectedDomain.regulation_domain_id.map(function (id) {
                                    return parseInt(id, 10);
                                });
                            } else {
                                ids = null;
                            }
                        } else {
                            ids = null;
                        }
                    }

                    scope.currentDomains = [];

                    if (ids !== null) {
                        ids.forEach(function (id) {
                            var domains = [];
                            if (utilsService.isSet(scope.selectedDomain.regulation_domain_id)) {
                                domains = scope.domains[DEFAULT_INDEX].filter(function (item) {
                                    return parseInt(item.id, 10) === id;
                                });
                            } else {
                                domains = scope.domains[id];
                            }
                            scope.currentDomains = scope.currentDomains.concat(domains || []);
                        });
                    }

                    if (!ignoreBreadcrumb) {
                        scope.breadcrumb.push(scope.selectedDomain);
                        $rootScope.$broadcast('regulation.domains.breadcrumb.set', {breadcrumb: scope.breadcrumb});
                    }

                    scope.onChange();
                };

                scope.goBack = function (toBegin) {
                    scope.selectedDomain = utilsService.last(scope.breadcrumb) || {};

                    if (scope.selectedDomain.regulation_domain_id || toBegin) {
                        scope.domains = scope.qualeveilleDomains;
                    }

                    if (toBegin) {
                        scope.breadcrumb = [];
                    } else {
                        scope.breadcrumb.pop();
                    }

                    scope.selectedDomain = utilsService.last(scope.breadcrumb) || {};
                    scope.currentDomains = [];

                    if (scope.hasSelectedDomain()) {
                        if (utilsService.isSet(scope.selectedDomain.regulation_domain_id)) {
                            if (angular.isArray(scope.selectedDomain.regulation_domain_id) && utilsService.isNotEmpty(scope.selectedDomain.regulation_domain_id)) {
                                scope.selectedDomain.regulation_domain_id.forEach(function (id) {
                                    var domains = scope.domains[DEFAULT_INDEX].filter(function (item) {
                                        return parseInt(item.id, 10) === parseInt(id, 10);
                                    });
                                    scope.currentDomains = scope.currentDomains.concat(domains || []);
                                });
                            }
                        } else {
                            scope.currentDomains = scope.domains[scope.selectedDomain.id];
                        }
                    } else {
                        scope.currentDomains = scope.domains[DEFAULT_INDEX];
                        scope.selectedDomain = {};
                    }
                    $rootScope.$broadcast('regulation.domains.breadcrumb.set', {breadcrumb: scope.breadcrumb});

                    scope.onChange();
                };

                scope.hasSelectedDomain = function () {
                    return utilsService.isNotEmpty(scope.selectedDomain);
                };

                scope.onChange = function () {
                    $rootScope.$broadcast('regulation.domains.change', {domain: scope.hasSelectedDomain() ? scope.selectedDomain : null});
                };

                $rootScope.$on('regulation.domains.goTo', function (e, data) {
                    if (!data || !data.domain) {
                        return;
                    }
                    var index = scope.breadcrumb.indexOf(data.domain);
                    var breadcrumbLength = scope.breadcrumb.length;
                    if (index === -1) {
                        return;
                    }
                    while (breadcrumbLength > index) {
                        breadcrumbLength--;
                        scope.breadcrumb.splice(breadcrumbLength, 1);
                    }
                    scope.goToDomain(data.domain, true);
                    scope.breadcrumb.push(data.domain);
                    $rootScope.$broadcast('regulation.domains.breadcrumb.set', {breadcrumb: scope.breadcrumb});
                });

                $rootScope.$on('regulation.domains.selected', function (e, data) {
                    data.id = data.id ? parseInt(data.id, 10) : 0;
                    data.parent_id = data.parent_id ? parseInt(data.parent_id, 10) : 0;
                    data.has_parent_qualeveille = Boolean(data.has_parent_qualeveille);

                    scope.domains = data.has_parent_qualeveille === true
                        ? scope.qualeveilleDomains
                        : scope.regulationDomains;

                    scope.selectedDomain = null;
                    var i, j;

                    if (data.has_parent_qualeveille) {
                        scope.currentDomains = [];

                        for (i in scope.domains) {
                            if (i === DEFAULT_INDEX) {
                                continue;
                            }
                            if (scope.currentDomains.length > 0) {
                                break;
                            }
                            if (scope.domains.hasOwnProperty(i)) {
                                for (j = 0; j < scope.domains[i].length; j++) {
                                    if (scope.domains[i][j].parent_id !== 0 && scope.domains[i][j].id === data.parent_id) {
                                        scope.currentDomains = scope.domains[i];
                                        break;
                                    }
                                }
                            }
                        }
                        scope.selectedDomain = scope.currentDomains.filter(function (domain) {
                            return domain.id === data.parent_id;
                        });
                        if (scope.selectedDomain && scope.selectedDomain.length) {
                            scope.selectedDomain = scope.selectedDomain[0];
                            scope.goToDomain(scope.selectedDomain);
                        }
                    } else {
                        scope.currentDomains = scope.domains[data.parent_id];

                        for (i in scope.domains) {
                            if (scope.selectedDomain !== null) {
                                break;
                            }
                            if (scope.domains.hasOwnProperty(i)) {
                                for (j = 0; j < scope.domains[i].length; j++) {
                                    if (scope.domains[i][j].id === data.parent_id) {
                                        scope.selectedDomain = scope.domains[i][j];
                                        break;
                                    }
                                }
                            }
                        }
                    }
                });

                scope.loading = true;
                RegulationApiService
                    .getDomainsByParentId()
                    .then(function (response) {
                        if (response) {
                            scope.qualeveilleDomains = response.domaines;
                            scope.regulationDomains = response.domaines_regulation;
                            scope.domains = scope.qualeveilleDomains;
                            scope.currentDomains = scope.domains[DEFAULT_INDEX];
                        }
                    })
                    .catch(console.error)
                    .then(function () {
                        $rootScope.$broadcast('regulation.domains.loaded');
                        scope.loading = false;
                    })
            }
        }
    }]);